import * as React from 'react';

import { EcgPlaceholderIcon } from '../../../assets/icons';

type ImageVariant = 'thumb' | 'fit';

export interface AssetImageProps {
  variant?: ImageVariant;
  style?: React.CSSProperties;
  alt?: string;
}

export function AssetImage({
  variant = 'thumb',
  style,
  alt = 'ECG waveform',
}: AssetImageProps) {
  const variantStyle: React.CSSProperties =
    variant === 'thumb'
      ? {
          width: '200%',
          height: '200%',
          objectFit: 'cover',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }
      : {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        };

  return (
    <EcgPlaceholderIcon
      aria-label={alt}
      style={{ ...variantStyle, ...style }}
    />
  );
}
